import React, { useState, useEffect } from 'react';

const QuestionCommentModal = ({ 
  isOpen, 
  onClose, 
  questionId, 
  existingComment, 
  onSave,
  modalTitle // ✅ New prop for custom title
}) => {
  const [comment, setComment] = useState('');

  useEffect(() => {
    if (isOpen) {
      setComment(existingComment || '');
    }
  }, [isOpen, existingComment]);

  const handleSave = () => {
    onSave(questionId, comment.trim());
    onClose();
  };

  const handleCancel = () => {
    setComment(existingComment || '');
    onClose();
  };

  if (!isOpen) return null;

  // ✅ Use custom title if provided, otherwise use default
  const displayTitle = modalTitle || `Add Comment for Question ID: ${questionId}`;

  return (
    <div className="popup-overlay-template-layout">
      <div 
        className="popup-box-template-layout"
        style={{
          width: "500px",
          maxHeight: "400px",
          padding: "20px"
        }}
      >
        <div style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: "20px"
        }}>
          <h3 style={{ margin: 0 }}>
            {displayTitle}
          </h3>
          <span
            style={{
              cursor: "pointer",
              fontSize: "20px",
              fontWeight: "bold",
              padding: "4px 8px",
              borderRadius: "4px",
              color: "#666",
            }}
            onClick={handleCancel}
            title="Close"
          >
            ×
          </span>
        </div>
        
        <div style={{ marginBottom: "20px" }}>
          <textarea
            value={comment}
            onChange={(e) => setComment(e.target.value)}
            placeholder="Enter your comment for this question..."
            style={{
              width: "100%",
              height: "120px",
              padding: "10px",
              border: "1px solid #ccc",
              borderRadius: "4px",
              resize: "vertical",
              fontFamily: "inherit",
              fontSize: "14px"
            }}
          />
        </div>
        
        <div style={{
          display: "flex",
          justifyContent: "flex-end",
          gap: "10px"
        }}>
          <button
            className="testreportcard-cancel-btn"
            onClick={handleCancel}
          >
            CANCEL
          </button>
          <button
            className="testreportcard-create-btn"
            onClick={handleSave}
          >
            SAVE 
          </button>
        </div>
      </div>
    </div>
  );
};

export default QuestionCommentModal;
